const textSv = {
  email: "E-postadress",
  emailRequired: "E-postadress är obligatoriskt",
  emailValid: "E-postadress måste vara giltig",
  passwordResetCode: "Återställningskod",
  passwordResetCodeRequired: "Återställningskodvär obligatorisk",
  password: "Lösenord",
  createPassword: "Skapa lösenord",
  confirmPassword: "bekräfta lösenord",
  back: "Tillbaka",
  forgotPassword: "Glömt lösenord",
  resetMyPassword: "Återställ lösenordet",
  continue: "Fortsätt",
  register: "Skapa konto",
  signIn: "Logga in",
  signUp: "Skapa konto",
  signUpForYourAccount: "Skapa konto",
  logInToYourAccount: "Logga in",
  confirmText: "Confirm your email",
  emailIsVerified: "Email has already been verified. Please go to login page.",
  emailNotVerified:
    "Confirmation token is expired. Please Sign Up again to get connect with us.",
  aVerificationLinkHaveBeenSentToYourEmail:
    "Ett verifikationse-postmeddelande har skickats till din mail",
  resetLinkSentToYourEmail: "Återställningskod har skickats till din mail",
  errors: {
    userDoesNotExist: "Kontot existerar inte",
    incorrectUsernameOrPassword: "Felaktigt användarnamn eller lösenord",
    loginFailed: "Inloggning misslyckades",
    invalidPasswordResetCode: "Felaktig återställningskod, försök igen.",
    userIsNotConfirmed: "Kontot är inte bekräftat.",
    default: {
      signIn: "Signin failed",
      resetPassword: "Password reset failed",
      resetPasswordLogin: "Password reset failed",
    },
  },
  confirmPasswordRules: "Lösenorden matchar inte",
  passwordRules: {
    required: "Password is mandatory",
    minlength: "The password must be at least 8 characters",
    maxlength: "The password should be 16 characters long.",
    uppercase: "The password must include a uppercase letter",
    lowercase: "The password must include a lowercase letter",
    spacecase: "Utrymme är inte tillåtet",
    digit: "The password must include a digit",
    special: "The password must include a special character",
  },
  eula: {
    expander: "By continuing login, you agree to Terms of Use",
    linkToToU: "SoftwareOnlineServiceToU",
    linkToDP: "SoftwareOnlineServiceDataPrivacy",
  },
};

export default textSv;
